export default __webpack_public_path__ + "static/media/leaderboard.3f60a453.svg";